import '@tnn/ui/styles.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { apps } from '@tnn/core'
import { createI18n } from '@tnn/i18n'
import { UiProvider } from '@tnn/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { en, th } from './locales'
import { SelfReceiptPageView } from './receipt'
import { SignDocumentPage } from './sign'

/**
 * The site customers sign documents on (sign.<domain>), apart from Thananan OS, with no sign-in, service worker or
 * installed app: `/<token>` of a signing link, and `/receipt/<code>/<payment>` where a company that paid a bill issues
 * the receipt in its name (from the bill's tracking page); only the API's signing-link and tracking endpoints behind
 * it (Caddyfile)
 */

const i18n = createI18n({ extra: { th: { sign: th }, en: { sign: en } } })
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } } })
// The link's one segment, as it was sent: tokens are URL-safe, and anything else is no link of ours
const [token = '', ...rest] = window.location.pathname.split('/').slice(1)
// A bill's payment: its tracking code and the payment
const receipt = token === 'receipt' ? { code: rest[0] ?? '', id: rest[1] ?? '' } : null

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <UiProvider seed={apps.portal.seed} locale="th" closeLabel={i18n.t('actions.close')}>
          {receipt ? <SelfReceiptPageView code={receipt.code} id={receipt.id} /> : <SignDocumentPage token={token} />}
        </UiProvider>
      </I18nextProvider>
    </QueryClientProvider>
  </StrictMode>,
)
